import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PartnerCard = ({ partner, onEdit, onViewLeads, onToggleStatus, onViewSalesforce, isSelected, onSelect }) => {
  const getStatusColor = (status) => {
    const colors = {
      verified: 'success',
      pending: 'warning',
      suspended: 'error',
    };
    return colors?.[status] || 'muted';
  };

  const getStatusIcon = (status) => {
    const icons = {
      verified: 'CheckCircle',
      pending: 'Clock',
      suspended: 'XCircle',
    };
    return icons?.[status] || 'Circle';
  };

  return (
    <div className={`bg-card rounded-lg border border-border p-6 elevation-1 hover:elevation-2 transition-all duration-200 ${isSelected ? 'ring-2 ring-primary' : ''}`}>
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={(e) => onSelect(partner?.id, e?.target?.checked)}
            className="w-4 h-4 rounded border-border text-primary focus:ring-2 focus:ring-ring focus:ring-offset-2 flex-shrink-0"
            aria-label={`Select ${partner?.companyName}`}
          />
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Building" size={24} color="var(--color-primary)" />
          </div>
          <div className="min-w-0">
            <h3 className="font-semibold text-foreground truncate">{partner?.companyName}</h3>
            <p className="text-sm text-muted-foreground truncate">{partner?.industry}</p>
          </div>
        </div>
        <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium bg-${getStatusColor(partner?.status)}/10 text-${getStatusColor(partner?.status)} flex-shrink-0`}>
          <Icon name={getStatusIcon(partner?.status)} size={14} />
          {partner?.status?.charAt(0)?.toUpperCase() + partner?.status?.slice(1)}
        </span>
      </div>
      <div className="space-y-3 mb-4">
        <div className="flex items-center gap-2 text-sm">
          <Icon name="User" size={16} className="text-muted-foreground flex-shrink-0" />
          <span className="text-foreground truncate">{partner?.contactName}</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Mail" size={16} className="text-muted-foreground flex-shrink-0" />
          <span className="text-foreground truncate">{partner?.email}</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Phone" size={16} className="text-muted-foreground flex-shrink-0" />
          <span className="text-foreground">{partner?.phone}</span>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-4 p-4 bg-muted/30 rounded-lg">
        <div>
          <p className="text-sm text-muted-foreground mb-1">Total Leads</p>
          <p className="text-xl font-semibold text-foreground">{partner?.totalLeads}</p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground mb-1">Converted</p>
          <p className="text-xl font-semibold text-success">{partner?.convertedLeads}</p>
        </div>
      </div>
      <div className="flex items-center justify-between text-sm text-muted-foreground mb-4">
        <span>Registered: {partner?.registrationDate}</span>
        <span>Last: {partner?.lastActivity}</span>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="ExternalLink"
          iconPosition="left"
          onClick={() => onViewSalesforce(partner?.salesforceId)}
          className="flex-1"
        >
          Salesforce
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="FileText"
          iconPosition="left"
          onClick={() => onViewLeads(partner?.id)}
          className="flex-1"
        >
          Leads
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Edit"
          onClick={() => onEdit(partner)}
        />
        <Button
          variant={partner?.status === 'suspended' ? 'success' : 'destructive'}
          size="sm"
          iconName={partner?.status === 'suspended' ? 'CheckCircle' : 'Ban'}
          onClick={() => onToggleStatus(partner)}
        />
      </div>
    </div>
  );
};

export default PartnerCard;